import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'edit_professional',
  })
  return async function onClick() {
    submit({ type: 'edit_office' })
  }
}
